// homepageStyles.js

export const classes = {
  footerSection: {
    background: '#333',
    color: '#ccc',
    padding: '40px 20px',
  },
  footerTop: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
    marginBottom: '20px',
  },
  aboutIntenceAI: {
    flex: '1 1 200px',
  },
  aboutHeading: {
    color: '#ffffff',
    marginBottom: '10px',
  },
  aboutText: {
    color: '#ccc',
    fontSize: '0.9rem',
    lineHeight: 1.4,
  },
  footerLinks: {
    display: 'flex',
    flex: 3,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  footerNav: {
    minWidth: '120px',
    marginBottom: '20px',
  },
  footerNavHeading: {
    color: '#fff',
    marginBottom: '10px',
    fontSize: '1rem',
  },
  footerUl: {
    listStyle: 'none',
    padding: 0,
  },
  footerLink: {
    textDecoration: 'none',
    color: '#ccc',
    fontSize: '0.9rem',
    '&:hover': {
      color: '#fff',
    },
  },
  footerBottom: {
    textAlign: 'center',
    fontSize: '0.8rem',
    color: '#999',
  },
};
